const codeQuestionAnswers = {
  NoAplicaNoSeEecomiendaContinueServicio: 393,
  SeRecomiendaContinueServicio: 394
};

export default codeQuestionAnswers;
